import type { GridRenderCellParams } from '@mui/x-data-grid-pro';
import type { TableRowType } from '../../../grid/reduxStore/table.types';
import { ColumnTypeIdentifier } from '../../../grid/reduxStore/table.types';
import { getIsCellEditingAllowed, TableNumericCell } from '../Table/tableUtils/customCellHelpers';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import UpDownArrowIcons from '../Table/components/UpDownArrowIcons';
interface PreviewEditableCellProps {
  params: GridRenderCellParams;
  columnType: ColumnTypeIdentifier;
  pricingDecimalPlaces?: number;
  updateRows: (updatedRow: TableRowType) => void;
  isDocumentLocked: boolean;
  documentCurrencySymbol?: string;
  valueSuffix?: string;
}

const PreviewEditableCellWrapper = ({
  params,
  columnType,
  pricingDecimalPlaces,
  updateRows,
  isDocumentLocked,
  documentCurrencySymbol,
  valueSuffix,
}: PreviewEditableCellProps): JSX.Element => {
  const { row, colDef, value } = params;
  const label = { inputProps: { 'aria-label': 'Optional row' } };
  const isCheckboxAvailable = (row?.isOptionalToggleAvailable && colDef['columnType'] === ColumnTypeIdentifier.OPTIONAL) ?? false;
  const isCellEditingAllowed = getIsCellEditingAllowed({ row, colDef });

  if (isCellEditingAllowed && !isDocumentLocked) {
    return (
      <Box component="span" display="flex" alignItems="center" gap="3px">
        <span className="py-numeric-cell-value">{String(value)}</span> <UpDownArrowIcons />
      </Box>
    );
  }
  if (isCheckboxAvailable) {
    return (
      <Checkbox
        {...label}
        className={!isDocumentLocked ? 'py-row-optional' : ''}
        data-testid="row-optional-preview-checkbox"
        disabled={isDocumentLocked}
        checked={row?.isRowOptional ?? false}
        onChange={() => updateRows({ ...row, isRowOptional: !row?.isRowOptional })}
      />
    );
  }

  return (
    <TableNumericCell
      isDocumentLocked={isDocumentLocked}
      params={params}
      columnType={columnType}
      numberOfDecimalPlaces={pricingDecimalPlaces}
      documentCurrencySymbol={documentCurrencySymbol}
      valueSuffix={valueSuffix}
    />
  );
};

export default PreviewEditableCellWrapper;
